<template>
    <div>

		<header id="header" class="full-header">
			<div id="header-wrap" class="">
				<div class="container">
					<div class="header-row top-search-parent">

						<!-- Logo
						============================================= -->
						<div id="logo">
							<h3 class="mb-0">AutoEspecialistas</h3>
						</div><!-- #logo end -->

						<div id="primary-menu-trigger">
							<svg class="svg-trigger" viewBox="0 0 100 100"><path d="m 30,33 h 40 c 3.722839,0 7.5,3.126468 7.5,8.578427 0,5.451959 -2.727029,8.421573 -7.5,8.421573 h -20"></path><path d="m 30,50 h 40"></path><path d="m 70,67 h -40 c 0,0 -7.5,-0.802118 -7.5,-8.365747 0,-7.563629 7.5,-8.634253 7.5,-8.634253 h 20"></path></svg>
						</div>

						<!-- Primary Navigation
						============================================= -->
						<nav class="primary-menu">

							<ul class="menu-container">
								<li class="menu-item sub-menu">
									<router-link to="/paineldegerenciamento" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Painel</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<router-link to="/paineldegerenciamento/servicos" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Serviços</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<router-link to="/paineldegerenciamento/clientes" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Clientes</div></router-link>
								</li>
								<!--
								<li class="menu-item sub-menu">
									<router-link to="/paineldegerenciamento/contratacoes" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Contratações</div></router-link>
								</li>
								-->
								<li class="menu-item mega-menu mega-menu-full sub-menu">
									<a class="menu-link" style="padding-top: 39px; padding-bottom: 39px; cursor:pointer;"><div>Tabelas<i class="icon-angle-down"></i></div></a>
									<div class="mega-menu-content" style="">
										<div class="container" style="">
											<div class="row">
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaativosfixos"><div>Ativos fixos</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listabeneficios"><div>Benefícios</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listacustosfixos"><div>Custos fixos</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listacustosvariaveis"><div>Custos variáveis</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaferramentas"><div>Ferramentas</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listafuncoes"><div>Funções colaboradores</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaInsumos"><div>Insumos</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listamarcas"><div>Marcas</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listamodelos"><div>Modelos</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaregimescontratacao"><div>Regimes de contratação</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaregimestributarios"><div>Regimes tributários</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaservicos"><div>Serviços</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listasetores"><div>Setores</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaperiodos"><div>Períodos</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaportesempresas"><div>Portes empresas</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listausuarios"><div>Usuários</div></router-link></li>
												</ul>
											</div>
										</div>
									</div>
								<button class="sub-menu-trigger icon-chevron-right"></button>
								</li>
								<li class="menu-item mega-menu mega-menu-full sub-menu">
									<a class="menu-link" style="padding-top: 39px; padding-bottom: 39px; cursor:pointer;"><div>Aprovação de tabelas<i class="icon-angle-down"></i></div></a>
									<div class="mega-menu-content" style="">
										<div class="container" style="">
											<div class="row">
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaativosfixos/aprovacao"><div>Ativos fixos</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listabeneficios/aprovacao"><div>Benefícios</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listacustosfixos/aprovacao"><div>Custos fixos</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listacustosvariaveis/aprovacao"><div>Custos variáveis</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaferramentas/aprovacao"><div>Ferramentas</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listafuncoes/aprovacao"><div>Funções colaboradores</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaInsumos/aprovacao"><div>Insumos</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listamarcas/aprovacao"><div>Marcas</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listamodelos/aprovacao"><div>Modelos</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaregimescontratacao/aprovacao"><div>Regimes de contratação</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaregimestributarios/aprovacao"><div>Regimes tributários</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaservicos/aprovacao"><div>Serviços</div></router-link></li>
												</ul>
												<ul class="sub-menu-container mega-menu-column col" style="">
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listasetores/aprovacao"><div>Setores</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaperiodos/aprovacao"><div>Períodos</div></router-link></li>
													<li class="menu-item"><router-link class="menu-link" tag="a" to="/paineldegerenciamento/listaportesempresas/aprovacao"><div>Portes empresas</div></router-link></li>
												</ul>
											</div>
										</div>
									</div>
								<button class="sub-menu-trigger icon-chevron-right"></button>
								</li>
								<li class="menu-item sub-menu">
									<a class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Sites<i class="icon-angle-down"></i></div></a>
									<ul class="sub-menu-container" style="">
										<li class="menu-item" style="">
											<router-link to="/autoespecialistas" class="menu-link"><div>AutoEspecialistas</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/gape/paineldegerenciamento" class="menu-link"><div>Gape</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/esinistros" class="menu-link"><div>E-sinistros</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/eoficinas" class="menu-link"><div>E-oficinas</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/paineldegerenciamento/blog" class="menu-link"><div>Blog</div></router-link>
										</li>
										<li class="menu-item" style="">
											<router-link to="/paineldegerenciamento" class="menu-link"><div>Sistema</div></router-link>
										</li>
									</ul>
								</li>

								<li class="menu-item sub-menu">
									<router-link :to="`/paineldegerenciamento/listausuarios/${idUsu}/editar/`" class="menu-link" style="padding-top: 39px; padding-bottom: 39px;"><div>Perfil</div></router-link>
								</li>
								<li class="menu-item sub-menu">
									<a @click.prevent="fnLogout()" class="menu-link" style="padding-top: 39px; padding-bottom: 39px; cursor:pointer"><div>Logout</div></a>
								</li>

							</ul>

						</nav><!-- #primary-menu end -->

					</div>
				</div>
			</div>
		</header>
		<div id="page-menu" class="no-sticky">
			<div id="page-menu-wrap">
				<div class="container">
					<div class="page-menu-row">

						<div class="page-menu-title" style="padding:10px 0;">&nbsp;</div>

					</div>
				</div>
			</div><div class="page-menu-wrap-clone" style="height: 48px;"></div>
		</div>		
    </div>
</template>

<script>
import {userKey} from '../../global/utils'
import {mapState} from 'vuex'
export default {
		data() {
			return {
			}
		},
		mounted() {
			this.updateList()
		},
		watch: {
		'$route' () {
		this.updateList()
		}
		},
		props:['secaoPrincipal','idUsu'],
		computed: {
			map: function(){
				return	mapState(['user','navSecao'])
			}
		},
		methods: {
		fnRouteTo(pRouteTo){
			if(this.breadcrumbList[pRouteTo].link) this.$router.push(this.breadcrumbList[pRouteTo].link)
		},
		updateList(){
			this.breadcrumbList = this.$route.meta.breadcrumb
		},
		fnMostraMenu(event){
			event.target.parentElement && event.target.nextSibling.classList.toggle("show");
		},
		toggleMenu(){
			this.$store.commit('toggleMenu');
		},
		fnLogout(){
			localStorage.removeItem(userKey);
			this.$store.commit('setUser',null)
			this.$router.push({name: 'auth'})
		}
	},

}
</script>

<style lang="less" scoped>
	#header-wrap{
		position: relative;
	}
	@media (min-width: 992px){
		.page-menu-sub-menu {
			min-width: 225px;
		}
	}
	#page-menu{
		margin-bottom: 45px !important;
	}
		

</style>